// extracted by mini-css-extract-plugin
export default {"container":"yI-z","disabled":"zI-z","bgBlack":"AI-z","content":"BI-z","countdown":"CI-z","topCaption":"DI-z","topHeading":"EI-z","heading":"FI-z","copy":"GI-z"};